import React, { useState } from 'react';
import { Button, Sheet } from 'geniebook-ui/dist';
import SortingMobile from '@components/progress/mobile/SortingMobile';
import { option } from 'geniebook-ui/dist/components/DropdownFilter/selection';
import Filter from '@assets/icons/filter';

export interface ApplyData<value> {
  selectedSort: value;
}

export interface FilterSheetProps<value> {
  sortOption: option<value>[];
  sortSelected: value;
  applyFilter: (data: ApplyData<value>) => void;
}

const FilterSheet = (props: FilterSheetProps<string | number>) => {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [showSheet, setShowSheet] = useState(false);
  const [selectedSort, setSelectedSort] = useState(props.sortSelected);

  function openSheet() {
    setShowSheet(true);
    setSheetOpen(true);
  }

  function hideSheet() {
    setSheetOpen(false);
    setShowSheet(false);
    setSelectedSort(props.sortSelected);
  }

  function applyFilter() {
    const data = {
      selectedSort,
    };
    props.applyFilter(data);
    hideSheet();
    setSelectedSort(data.selectedSort);
  }

  return (
    <div>
      <div
        className={
          'py-3 px-4 rounded-2xl border border-neutral-chalk text-neutral-chalk bg-primary-navyblue-dim text-sm font-bold w-fit leading-3.5'
        }
        onClick={() => openSheet()}
      >
        <Filter
          className={
            'fill-current inline-block text-primary-apricot w-3.5 h-3.5 mr-2'
          }
        />
        Filter
      </div>
      {showSheet ? (
        <Sheet
          isOpen={sheetOpen}
          toggleSheet={() => hideSheet()}
          zIndex={21}
          closeHeight={'0'}
        >
          <div className={'p-4 w-full'}>
            <SortingMobile
              options={props.sortOption}
              selected={selectedSort}
              setSelection={value => {
                setSelectedSort(value);
              }}
            />
            <Button
              onClick={() => applyFilter()}
              className={'w-full'}
              style={{ maxWidth: '100%', fontWeight: '900' }}
            >
              Apply Filter
            </Button>
            <Button
              onClick={() => hideSheet()}
              variant={'secondary'}
              className={'w-full'}
              style={{ maxWidth: '100%' }}
            >
              Cancel
            </Button>
          </div>
          <div className={'max-md:h-[60px] md:h-[56px]'} />
        </Sheet>
      ) : null}
    </div>
  );
};

export default FilterSheet;
